import styled from "styled-components";

export const DeltaStyles = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1px;
  padding: 2px 6px;
  border-radius: 999px;

  &.delta--up {
    background: ${({ theme }) => theme.colors.success[50]};
    color: ${({ theme }) => theme.colors.success[700]};
  }
  &.delta--down {
    background: ${({ theme }) => theme.colors.error[50]};
    color: ${({ theme }) => theme.colors.error[600]};
  }
  &.delta--flat {
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.accent[500]};
  }
`;
